import { Pipe, PipeTransform } from '@angular/core';
import { interval, Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: false,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string): Observable<{ value: number | null; label: string }> {
    if (!value) {
      return of({ value: null, label: 'just now' });
    }

    const date = typeof value === 'string' ? new Date(value) : value;

    return interval(60000).pipe(
      startWith(0),
      map(() => this.getTimeAgo(date))
    );
  }

  private getTimeAgo(date: Date): { value: number | null; label: string } {
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    let interval = seconds / 31536000;
    if (interval > 1) {
      return { value: Math.floor(interval), label: 'years ago' };
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return { value: Math.floor(interval), label: 'months ago' };
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return { value: Math.floor(interval), label: 'days ago' };
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return { value: Math.floor(interval), label: 'hours ago' };
    }
    interval = seconds / 60;
    if (interval > 1) {
      return { value: Math.floor(interval), label: 'minutes ago' };
    }
    return { value: null, label: 'just now' };
  }
}

